import { useMemo } from 'react';
import { useIsUngated } from '../../../hooks/useIsUngated';
import { GROW_GUIDE_FREE_GATE } from '../constants/gates';
export const useGrowGuide = () => {
  const shouldRenderGrowGuide = useIsUngated(GROW_GUIDE_FREE_GATE);
  return useMemo(() => {
    return {
      shouldRenderGrowGuide
    };
  }, [shouldRenderGrowGuide]);
};